import React, { useState } from 'react';
import { useSelected, useReadOnly } from 'slate-react';
import { icons } from '@ublend-npm/aulaui-next';
import { AudioPlayer } from '../AudioPlayer/AudioPlayer';
import {
  AudioContainer,
  AudioPlayerWrapper,
  BlockButton,
  BrokenFileContainer,
  FailedAudioLoad,
  FailedDescription,
  Title,
} from './File.styled';
import { useAulaEditorContext } from '../../EditorContext';

export type FileAudioProps = {
  type?: string;
  src: string;
  name?: string;
  entityId: string;
};

export const FileAudio = (props: FileAudioProps) => {
  const { src, name, entityId } = props;
  const isSelected = useSelected();
  const isReadOnly = useReadOnly();
  const { updateEntity } = useAulaEditorContext();
  const [brokenLink, setBrokenLink] = useState(false);

  if (brokenLink) {
    return (
      <FailedAudioLoad
        isSelected={isSelected}
        aria-current={isSelected}
        data-testid="broken-link"
      >
        <icons.WarningIcon />
        <BrokenFileContainer>
          <FailedDescription>
            There was an error loading this audio file
            {!isReadOnly && (
              <>
                <br />
                <BlockButton
                  onClick={() => {
                    setBrokenLink(false);
                  }}
                >
                  Retry
                </BlockButton>
              </>
            )}
          </FailedDescription>
        </BrokenFileContainer>
      </FailedAudioLoad>
    );
  }

  return (
    <AudioContainer
      data-testid="audio-block"
      isSelected={isSelected}
      aria-current={isSelected}
    >
      <Title>{name}</Title>
      <AudioPlayerWrapper>
        <AudioPlayer
          src={src}
          onError={() =>
            isReadOnly
              ? setBrokenLink(true)
              : updateEntity(entityId, { failed: true })
          }
        />
      </AudioPlayerWrapper>
    </AudioContainer>
  );
};
